export function secondsToStamp (seconds) {
  if (typeof seconds !== 'number') return seconds

  let iso = new Date(seconds * 1000).toISOString()
  let start = 11
  let end = 8

  if (iso.substr(start, 2) === '00') {
    start = 14
    end = 5
  }

  return iso.substr(start, end)
}

export function stampToSeconds (stamp) {
  let time = typeof value === 'number' ? secondsToStamp(stamp).split(':') : stamp.split(':')

  time = time
    .map((t) => parseInt(t))
    .filter((t) => t >= 0)

  if (time.length === 3) {
    return (time[0] * 3600) + (time[1] * 60) + time[2]
  } else if (time.length === 2) {
    return (time[0] * 60) + time[1]
  }

  if (time[0] >= 60) return stampToSeconds(time[0])

  return time[0]
}

export function millisecondsToStamp (milliseconds) {
  if (typeof milliseconds !== 'number') return milliseconds

  let iso = new Date(milliseconds).toISOString()
  let start = 11
  let end = 12

  if (iso.substr(start, 2) === '00') {
    start = 14
    end = 9
  }

  if (iso.substr(19, 4) === '.000') {
    end = end - 4
  }

  return iso.substr(start, end)
}

export function stampToMilliseconds (stamp) {
  let stampSplit = stamp.split('.')
  let seconds = stampSplit[0]
  let milliseconds = stampSplit[1] ? parseFloat('.' + stampSplit[1]) : 0
  milliseconds = parseInt(milliseconds * 1000)

  let time = seconds.split(':')

  time = time
    .map((t) => parseInt(t))
    .filter((t) => t >= 0)

  if (time.length === 3) {
    return (((time[0] * 3600) + (time[1] * 60) + time[2]) * 1000) + milliseconds
  } else if (time.length === 2) {
    return (((time[0] * 60) + time[1]) * 1000) + milliseconds
  }

  if (time[0] >= 60) {
    return stampToMilliseconds(`${time[0]}.${milliseconds}`)
  }

  return (time[0] * 1000) + milliseconds
}

export function getMarkerType (markerName) {
  if (!markerName) return null
  const name = markerName.toLowerCase()
  if (name.includes('pre')) return 'pre'
  if (name.includes('post')) return 'post'
  return 'mid'
}

function getEndStamp (markerOffset, bakedInDuration, isPost) {
  if (isPost) {
    return bakedInDuration ? millisecondsToStamp(markerOffset - bakedInDuration) : null
  }
  return bakedInDuration ? millisecondsToStamp(markerOffset + bakedInDuration) : null
}

export function getMarkerFormValues (pre, post, mids, episode, podcast) {
  let markers = {
    pre: {
      ad_type: 'pre',
      name: 'Pre-roll 1',
      stamp: '00:00',
      end_stamp: null,
      limit: 0,
      type: 'default',
      max_duration_milliseconds: 0,
      effective_date: null,
      canEditTimestamp: true
    },
    post: {
      ad_type: 'post',
      name: 'Post-roll 1',
      stamp: millisecondsToStamp(((episode && episode.duration) || 0) * 1000),
      end_stamp: null,
      limit: 0,
      type: 'default',
      max_duration_milliseconds: 0,
      effective_date: null,
      canEditTimestamp: true
    },
    mid_1: {
      ad_type: 'mid',
      name: 'Mid-roll 1',
      stamp: null,
      end_stamp: null,
      limit: 0,
      type: 'default',
      max_duration_milliseconds: 0,
      effective_date: null,
      canEditTimestamp: true
    },
    mid_2: {
      ad_type: 'mid',
      name: 'Mid-roll 2',
      stamp: null,
      end_stamp: null,
      limit: 0,
      type: 'default',
      max_duration_milliseconds: 0,
      effective_date: null,
      canEditTimestamp: true
    },
    mid_3: {
      ad_type: 'mid',
      name: 'Mid-roll 3',
      stamp: null,
      end_stamp: null,
      limit: 0,
      type: 'default',
      max_duration_milliseconds: 0,
      effective_date: null,
      canEditTimestamp: true
    },
    mid_4: {
      ad_type: 'mid',
      name: 'Mid-roll 4',
      stamp: null,
      end_stamp: null,
      limit: 0,
      type: 'default',
      max_duration_milliseconds: 0,
      effective_date: null,
      canEditTimestamp: true
    },
    mid_5: {
      ad_type: 'mid',
      name: 'Mid-roll 5',
      stamp: null,
      end_stamp: null,
      limit: 0,
      type: 'default',
      max_duration_milliseconds: 0,
      effective_date: null,
      canEditTimestamp: true
    }
  }
  const timeLimitEnabled = episode && episode.markers && episode.markers.max_marker_duration_enabled
  // todo: I think we could probably simplify this to be less repeating
  // but I don't feel like a full refactor/test today since offset needs to go out next week.
  if (episode && episode.id) {
    if (pre) {
      markers.pre.stamp = millisecondsToStamp(pre.offset_milliseconds)
      markers.pre.end_stamp = getEndStamp(pre.offset_milliseconds, pre.baked_in_duration_milliseconds)
      markers.pre.limit = pre.ad_limit
      markers.pre.id = pre.id
      markers.pre.max_duration_milliseconds = timeLimitEnabled ? pre.max_duration_milliseconds || 0 : 0
      markers.pre.type = pre.baked_in_duration_milliseconds ? 'bakedin' : 'default'
      markers.pre.href = pre.href
      markers.pre.effective_date = pre.effective_date
      markers.pre.canEditTimestamp = 'offset_milliseconds' in pre.update.input
    }
    if (post) {
      markers.post.stamp = post.offset_milliseconds ? millisecondsToStamp(post.offset_milliseconds) : millisecondsToStamp((episode.duration || 0) * 1000)
      markers.post.end_stamp = getEndStamp(post.offset_milliseconds, post.baked_in_duration_milliseconds, true)
      markers.post.limit = post.ad_limit
      markers.post.id = post.id
      markers.post.max_duration_milliseconds = timeLimitEnabled ? post.max_duration_milliseconds || 0 : 0
      markers.post.type = post.baked_in_duration_milliseconds ? 'bakedin' : 'default'
      markers.post.href = post.href
      markers.post.effective_date = post.effective_date
      markers.post.canEditTimestamp = 'offset_milliseconds' in post.update.input
    }
    if (mids && mids.length) {
      for (let i = 1; i <= 5; i++) {
        const roll = mids.find(m => m.name.includes(i))
        if (roll) {
          markers['mid_' + i].stamp = millisecondsToStamp(roll.offset_milliseconds)
          markers['mid_' + i].end_stamp = getEndStamp(roll.offset_milliseconds, roll.baked_in_duration_milliseconds)
          markers['mid_' + i].limit = roll.ad_limit
          markers['mid_' + i].id = roll.id
          markers['mid_' + i].max_duration_milliseconds = timeLimitEnabled ? roll.max_duration_milliseconds || 0 : 0
          markers['mid_' + i].type = roll.baked_in_duration_milliseconds ? 'bakedin' : 'default'
          markers['mid_' + i].href = roll.href
          markers['mid_' + i].effective_date = roll.effective_date
          markers['mid_' + i].canEditTimestamp = true
        }
      }
    }
  } else {
    const preLimit = podcast.default_marker_ad_limit_pre_enabled && podcast.default_marker_ad_limit_pre
    const postLimit = podcast.default_marker_ad_limit_post_enabled && podcast.default_marker_ad_limit_post
    markers.pre.limit = preLimit || 0
    markers.post.limit = postLimit || 0
  }
  return markers
}
